type StructuredPriceSlot = {
  regularHours?: number;
  perPersonHours?: number;
};

type StructuredPrice = {
  weekday?: StructuredPriceSlot;
  weekend?: StructuredPriceSlot;
};

export const getStructuredPriceValue = (
  priceSlot?: StructuredPriceSlot | null,
): number | null => {
  if (typeof priceSlot?.regularHours === "number") {
    return priceSlot.regularHours;
  }

  if (typeof priceSlot?.perPersonHours === "number") {
    return priceSlot.perPersonHours;
  }

  return null;
};

export const getStructuredWeekdayPrice = (
  price?: StructuredPrice | null,
): number | null => getStructuredPriceValue(price?.weekday);